
export const POND_TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'prestocking', label: 'Pre-stocking' },
  { id: 'stocking', label: 'Stocking' },
  { id: 'parameters', label: 'Parameters' },
  { id: 'applications', label: 'Applications' },
  { id: 'feeding', label: 'Feeding' },
  { id: 'sampling', label: 'Sampling' },
  { id: 'harvests', label: 'Harvests' },
] as const;

export type PondTab = (typeof POND_TABS)[number]['id'];

const TAB_IDS = new Set<string>(POND_TABS.map((t) => t.id));

export function parsePondTab(raw: unknown): PondTab | undefined {
  return typeof raw === 'string' && TAB_IDS.has(raw) ? (raw as PondTab) : undefined;
}

const NEEDS_STOCKING = new Set<PondTab>(['stocking', 'feeding', 'sampling', 'harvests']);

/** Why a tab is closed for this crop, or null when it opens. */
export function tabClosedReason(tab: PondTab, crop: { status: string; stocking_date?: string | null } | null): string | null {
  if (!crop || crop.stocking_date || !NEEDS_STOCKING.has(tab)) return null;
  return crop.status === 'preparing' ? 'Opens when the pond is stocked' : 'This crop was never stocked';
}
